import { Injectable } from '@angular/core';
import { SenderSubscriptionClientStatus, TrafficType } from '@campaign-portal/namespace/common/enums';
import { AlarisProfileService } from '@campaign-portal/components-library';
import { MessageTemplate } from '@campaign-portal/namespace/entities/templates/specs';
import { Campaign, CampaignOmniSettings, CampaignStatus } from '@campaign-portal/namespace/entities/campaigns/specs';
import { CampaignWizardService } from '../../../../campaign-wizard/campaign-wizard.service';
import { SendersService } from '@shared/services';

@Injectable({
	providedIn: 'root',
})
export class MessageTemplateUtilsService {
	constructor(
		private readonly profileService: AlarisProfileService,
		private readonly sendersService: SendersService,
		private readonly cw: CampaignWizardService
	) {}

	hasActiveSender(template: MessageTemplate): boolean {
		return Boolean(
			template.sender?.id &&
				this.sendersService.map.get(template.sender.id)?.status === SenderSubscriptionClientStatus.ENABLED
		);
	}

	isPreModeratedChannel(trafficType?: TrafficType): boolean {
		const preModerateChannels = this.profileService.user.details.preModerateTemplateChannels ?? [];
		return Boolean(trafficType === TrafficType.WHATSAPP || (trafficType && preModerateChannels.includes(trafficType)));
	}

	createCampaign(template?: MessageTemplate): void {
		if (!template) {
			return;
		}
		const campaign: Campaign = {
			id: null,
			info: {
				id: null,
				name: template.name,
				scheduled: '',
				status: CampaignStatus.SCHEDULED,
			},
			settings: {
				isFlashed: this.profileService.user.details.isFlashed ? template.isFlashed : undefined,
			},
			setup: {
				channels: [
					{
						sender: template.sender?.id as number,
						message: {
							text: template.messageTemplate,
							templateID: template.id || undefined,
						},
						trafficType: template.channelType || TrafficType.SMS,
						omni: this.createCampaignOmniSettings(template),
					},
				],
			},
		};
		this.cw.repeat(campaign);
	}

	private createCampaignOmniSettings(template: MessageTemplate): CampaignOmniSettings | undefined {
		switch (template.channelType) {
			case TrafficType.VIBER:
				return { viberSettings: template.viberSettings };
			case TrafficType.WHATSAPP:
				return { whatsappSettings: template.whatsappSettings };
			case TrafficType.SMS: {
				return { smsSettings: template.smsSettings };
			}
			default:
				return undefined;
		}
	}
}
